import {jsonMember, jsonObject} from "typedjson";
import {DxBaseUiOptions} from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";


/**
 * Опции верхнего меню навигатора.
 * @publicApi
 */
@jsonObject
export class DxHeadNavigationMenuOptions extends DxBaseUiOptions {
  @jsonMember({name: "showHomeBtn", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _showHomeBtn: boolean = true;

  @jsonMember({name: "homeBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _homeBtnIcon: string;

  @jsonMember({name: "useCarousel", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _useCarousel: boolean = true;

  @jsonMember({name: "prevBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _prevBtnIcon: string;

  @jsonMember({name: "nextBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _nextBtnIcon: string;

  @jsonMember({name: "maxCountOfDisplayedItems", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _maxCountOfDisplayedItems: number = 7;

  get homeBtnIcon(): string {
    return this._homeBtnIcon;
  }

  set homeBtnIcon(value: string) {
    this._homeBtnIcon = value;
  }

  get showHomeBtn(): boolean {
    return this._showHomeBtn;
  }

  set showHomeBtn(value: boolean) {
    this._showHomeBtn = value;
  }

  get useCarousel(): boolean {
    return this._useCarousel;
  }

  get prevBtnIcon(): string {
    return this._prevBtnIcon;
  }

  set prevBtnIcon(value: string) {
    this._prevBtnIcon = value;
  }

  get nextBtnIcon(): string {
    return this._nextBtnIcon;
  }

  set nextBtnIcon(value: string) {
    this._nextBtnIcon = value;
  }

  set useCarousel(value: boolean) {
    this._useCarousel = value;
  }

  get maxCountOfDisplayedItems(): number {
    return this._maxCountOfDisplayedItems;
  }

  set maxCountOfDisplayedItems(value: number) {
    this._maxCountOfDisplayedItems = value;
  }
}
